module.exports = __webpack_public_path__ + "assets/icons/touch.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/touch.svg
// module id = dUbX
// module chunks = 1